var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.area)?_c('Geometry',{attrs:{"geojson":_vm.area.geometry,"color":_vm.color},on:{"click":function($event){return _vm.$emit("click", _vm.area)}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }